import React, { useContext, useEffect, useState } from 'react';
import { Box, Grid, Card, Stack, Typography, Container } from '@mui/material';
import { genericGet } from '../../services/apiServices';
import { GET_DASHBOARD_LIST } from '../../services/apiRoutes';
import { AuthContext } from '../../context/AuthContext';
import { t } from '../../constants/translationHelper';
import DirectionsBoatOutlinedIcon from '@mui/icons-material/DirectionsBoatOutlined';
import ImportshipmetIcon from '../../assets/images/importshipmetIcon.png';
import ExportshipmetIcon from '../../assets/images/exportshipmetIcon.png';
import TopExportContainer from '../../assets/images/topExportContainer.png';
import TopImportContainer from '../../assets/images/topImportContainer.png';
import ImportCompleteContainer from '../../assets/images/importCompleteContainer.png';
import ImportContainerOnPort from '../../assets/images/importContainerOnPort.png';
import ImportPendingContainers from '../../assets/images/importPendingContainers.png';
import ImportInTransitContainers from '../../assets/images/importInTransitContainers.png';
import ExportContainersOnPort from '../../assets/images/exportContainersOnPort.png';
import ExportCompleteContainers from '../../assets/images/exportCompleteContainers.png';
import ExportPendingContainers from '../../assets/images/exportPendingContainers.png';
import ExportInTransitContainers from '../../assets/images/exportInTransitContainers.png';

const colorMap = {
    // 1: { backgroundColor: '#10cced80', color: '#000000BF', borderColor: '#ceebf2' },
    1: { backgroundColor: '#d3eff480', color: '#000000BF', borderColor: '#ceebf2' },
    2: { backgroundColor: '#F8F7FF', color: '#000000BF', borderColor: '#DFDCF3' },
    3: { backgroundColor: '#EDFFF0', color: '#000000BF', borderColor: '#BDE5C3' },
    4: { backgroundColor: '#F8F8FB', color: '#000000BF', borderColor: '#C2C2CC' },

    5: { backgroundColor: '#F5F5F5', color: '#000000BF', borderColor: '#e2dede ' },
    6: { backgroundColor: '#FBFCF6', color: '#000000BF', borderColor: '#D4D4D4' },
    7: { backgroundColor: '#FCF8EB', color: '#000000BF', borderColor: '#D6CFB8' },
    8: { backgroundColor: '#F9EFE8', color: '#000000BF', borderColor: '#EED6C5' },

    9: { backgroundColor: '#F5FBF2', color: '#000000BF', borderColor: '#DADED9' },
    10: { backgroundColor: '#FFF9FE', color: '#000000BF', borderColor: '#F5E0F1' },
    11: { backgroundColor: '#DDFFF8', color: '#000000BF', borderColor: '#649288' },
    12: { backgroundColor: '#EFFFC566', color: '#000000BF', borderColor: '#CCD1C0' },
};

// ✅ Map ids to icons
const iconMap = {
    1: (
        <img
            src={ImportshipmetIcon}
            alt="Import Shipment"
            style={{ width: 60, height: 60 }}
        />
    ),
    2: (
        <img
            src={ExportshipmetIcon}
            alt="Export Shipment"
            style={{ width: 60, height: 60 }}
        />
    ),
    3: (
        <img
            src={TopImportContainer}
            alt="Export Shipment"
            style={{ width: 60, height: 60 }}
        />
    ),
    4: (
        <img
            src={TopExportContainer}
            alt="Export Shipment"
            style={{ width: 60, height: 60 }}
        />
    ),
    5: (
        <img
            src={ImportContainerOnPort}
            alt="Export Shipment"
            style={{ width: 60, height: 60 }}
        />
    ),
    6: (
        <img
            src={ImportCompleteContainer}
            alt="Export Shipment"
            style={{ width: 60, height: 60 }}
        />
    ),
    7: (
        <img
            src={ImportPendingContainers}
            alt="Export Shipment"
            style={{ width: 60, height: 60 }}
        />
    ),
    8: (
        <img
            src={ImportInTransitContainers}
            alt="Export Shipment"
            style={{ width: 60, height: 60 }}
        />
    ),
    9: (
        <img
            src={ExportContainersOnPort}
            alt="Export Shipment"
            style={{ width: 60, height: 60 }}
        />
    ),
    10: (
        <img
            src={ExportCompleteContainers}
            alt="Export Shipment"
            style={{ width: 60, height: 60 }}
        />
    ),
    11: (
        <img
            src={ExportPendingContainers}
            alt="Export Shipment"
            style={{ width: 60, height: 60 }}
        />
    ),
    12: (
        <img
            src={ExportInTransitContainers}
            alt="Export Shipment"
            style={{ width: 60, height: 60 }}
        />
    ),
};



const CustomCard = ({ title, value, icon, style }) => {

    return (
        <Card
            variant="outlined"
            sx={{
                ...style,
                borderRadius: "5px",
                height: "100%",
                position: "relative",
                border: `2px solid ${style.borderColor}`,
                overflow: "visible",
            }}
        >

            {/* VALUE BADGE HALF OUTSIDE */}
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    transform: "translate(50%, -50%)",
                    px: 2,
                    py: 0.5,
                    borderRadius: "5px",
                    border: `2px solid ${style.borderColor}`,
                    backgroundColor: style.backgroundColor,
                    color: style.color,
                    fontWeight: 700,
                    fontSize: "14px",
                    minWidth: "40px",
                    textAlign: "center",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",

                }}
            >
                {value}
            </Box>

            <Box
                sx={{
                    p: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 2
                }}
            >

                {/* Icon */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: {
                            xs: "28px",
                            sm: "32px",
                            md: "36px",
                            lg: "40px",
                        },
                        color: style.color
                    }}
                >
                    {icon || <DirectionsBoatOutlinedIcon />}
                </Box>
                <Box
                    sx={{
                        height: "60px",
                        borderLeft: `2px solid ${style.color}`,
                        opacity: 0.4
                    }}
                />
                <Stack sx={{ flex: 1 }}>
                    <Typography
                        variant="subtitle1"
                        sx={{
                            fontWeight: 600,
                            fontSize: "16px"
                        }}
                    >
                        {t(title)}
                    </Typography>
                </Stack>

            </Box>

        </Card>
    );
};
const DashboardCard = () => {
    const [cardData, setCardData] = useState([]);
    const { token } = useContext(AuthContext)
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await genericGet({ url: GET_DASHBOARD_LIST });
                if (response.data && response.data.success && response.data.cardData) {
                    setCardData(response.data.cardData);
                } else {
                    console.error('Failed to fetch data:', response.data);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [token]);


    return (
        <Container
            maxWidth={false}
            sx={{
                px: { xs: 1, sm: 2, md: 3, lg: 4 },
            }}
        >

            <Box sx={{ p: 2, mt: 2 }}>
                <Grid container columnSpacing={4} rowSpacing={4}>
                    {cardData.map((data, index) => (
                        <Grid item xs={12} sm={4} md={3} key={index}>
                            <CustomCard
                                title={data.title}
                                value={data.value}
                                icon={iconMap[data.id] || <DirectionsBoatOutlinedIcon />}
                                style={colorMap[data.id] || { backgroundColor: '#ffffff', color: '#000000' }}
                            />
                        </Grid>
                    ))}
                </Grid>
                <br />
            </Box>
        </Container>
    );
};



export default DashboardCard;



